<template>
  <section>
    <h3 class="title_header">政务文件管理</h3>
    <div class="container">
      <div class="left">
        <div class="treeHeader"><el-button type="primary" @click="addLevelNode">新增</el-button></div>
        <el-tree default-expand-all node-key="pid" :data="treeData" :props="defaultProps" :expand-on-click-node="false" @node-click="handleNodeClick">
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <span> <i :class="{ 'icon-folder': data.nodeType == 1, [`icon-${data.fileType}`]: data.nodeType == 2 }"></i> {{ node.label }} </span>
            <span>
              <i class="el-icon-delete" style="color: #f56c6c" @click="removeNode(node, data)"></i>
            </span>
          </div>
        </el-tree>
      </div>
      <div class="right">
        <div class="header">
          <h3>{{ previewForm.name }}</h3>
          <!--          <el-button type="primary" v-if="previewForm.nodeType == 2 && (previewForm.fileType == 'zip' || previewForm.fileType == 'rar')" @click="handleDown">下载</el-button>-->
          <el-button type="primary" v-if="previewForm.nodeType == 2" @click="handleDown">下载</el-button>
        </div>
        <div>
          <div class="empty" v-if="previewForm.nodeType == 1">
            <img src="../../assets/images/empty.svg" />
            <p>当前为文件夹，不可查看、下载</p>
          </div>
          <div class="empty" v-if="previewForm.nodeType == 2 && (previewForm.fileType == 'zip' || previewForm.fileType == 'rar')">
            <img src="../../assets/images/zip.svg" />
            <p>压缩包请下载后查看</p>
          </div>
          <div style="width: 100%; height: 700px; overflow-y: auto" v-if="previewForm.nodeType == 2 && previewForm.fileType == 'pdf'">
            <pdf v-for="item in numPages" :key="item" :src="previewForm.officeUrl" :page="item" ref="pdf"></pdf>
          </div>
          <div style="width: 100%; height: 700px; overflow-y: auto" v-if="previewForm.nodeType == 2 && ['png', 'jpg'].includes(previewForm.fileType)">
            <el-image :src="previewForm.fileUrl" fit="cover"></el-image>
          </div>
          <iframe :src="previewForm.officeUrl" frameborder="0" width="100%" height="700px" v-if="previewForm.nodeType == 2 && ['doc', 'docx', 'xls', 'xlsx'].includes(previewForm.fileType)"></iframe>
        </div>
      </div>
      <!-- 新增/编辑 -->
      <el-dialog :title="editForm.nodeType == 1 || !editForm.nodeType ? '新增文件夹' : '新增文件'" :visible.sync="dialogVisible" :before-close="dialogCancel" width="600px">
        <el-form :model="editForm" ref="editForm" inline label-position="left" label-width="130px">
          <el-form-item label="类型：" prop="nodeType" :rules="[{ required: true, message: '请选择类型', trigger: 'blur' }]">
            <el-select v-model="editForm.nodeType" placeholder="请选择" clearable style="width: 260px">
              <el-option label="文件夹" :value="1"></el-option>
              <el-option label="文件" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文件夹名称：" prop="name" :rules="[{ required: true, message: '请输入文件名称', trigger: 'blur' }]" v-if="editForm.nodeType == 1 || !editForm.nodeType">
            <el-input v-model="editForm.name" placeholder="请输入文件名称" style="width: 260px"></el-input>
          </el-form-item>
          <el-form-item label="父级：" v-show="editForm.nodeType == 2">
            <select-tree
              ref="selectTree"
              :options="treeData"
              :value="editForm.parentId"
              :valueTitle="editForm.name"
              :clearable="true"
              :accordion="true"
              @getValue="getValue(arguments)"
              style="width: 260px"
            ></select-tree>
          </el-form-item>
          <el-form-item label="上传文件：" v-show="editForm.nodeType == 2">
            <el-upload action :show-file-list="false" :http-request="uploadObs" :auto-upload="true" :before-upload="beforeUpload">
              <el-button size="small" type="primary">上传附件</el-button>
              <div slot="tip" class="el-upload__tip">仅支持：word、excel、ppt、pdf、jpg、png、zip、rar文件</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogCancel">取 消</el-button>
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import pdf from 'vue-pdf'
import SelectTree from '@/components/select-tree'
import ObsClient from 'esdk-obs-browserjs/src/obs'
import Config from '@/utils/app.config'
export default {
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      editForm: {
        nodeType: null,
        parentId: null
      },
      previewForm: {},
      dialogVisible: false,
      numPages: null // pdf 总页数
    }
  },
  components: { pdf, SelectTree },
  created() {
    this.getTreeList()
  },
  mounted() {},
  methods: {
    //获取政务文件树形结构
    getTreeList() {
      this.$post(this.$url.获取政务文件树形结构, { nodeType: 0 })
        .then((res) => {
          this.treeData = res
        })
        .catch((e) => {})
    },
    //下拉树控件
    getValue(params) {
      this.editForm.parentId = params[0]
    },
    //新增父节点
    addLevelNode() {
      this.dialogVisible = true
    },
    // 删除树节点
    removeNode(node, data) {
      event.stopPropagation()
      let msg = ''
      if (!data.children.length) {
        msg = `确认删除版本"${data.name}"？`
      } else {
        msg = `版本"${data.name}"下已关联知识，请解除知识绑定后再操作！`
      }
      this.$confirm(msg, '删除', {
        type: 'warning'
      })
        .then(() => {
          if (data.children.length) return
          this.$post(this.$url.政务文件删除, { pid: data.pid })
            .then((res) => {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getTreeList()
              location.reload()
            })
            .catch((e) => {})
        })
        .catch((e) => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 计算pdf页码总数
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.previewForm.officeUrl)
      loadingTask.promise
        .then((pdf) => {
          this.numPages = pdf.numPages
        })
        .catch((err) => {
          console.error('pdf 加载失败', err)
        })
    },
    // 点击当前节点预览文件
    handleNodeClick(data) {
      this.previewForm = data
      if (data.fileType == 'pdf') {
        this.previewForm.officeUrl = data.fileUrl
        this.getNumPages()
      } else if (['doc', 'docx', 'xls', 'xlsx'].includes(data.fileType)) {
        this.previewForm.officeUrl = 'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(data.fileUrl)
      }
    },
    // 下载文件
    handleDown() {
      window.location.href = this.previewForm.fileUrl
    },
    // 文件类型限制
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)
      const whiteList = ['png', 'jpg', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'zip', 'rar']
      this.editForm.fileType = fileSuffix
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.error('上传文件格式不正确')
        return false
      }
    },
    // 文件上传
    uploadObs(file) {
      // 创建ObsClient实例
      let obsClient = new ObsClient({
        access_key_id: Config.obsAccessKeyId,
        secret_access_key: Config.obsSecretAccessKey,
        server: Config.obsServer
      })
      this.$post(this.$url.获取UUID, {})
        .then((res) => {
          let loading = this.$loading({
            lock: true,
            text: '上传中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          let thit = this
          obsClient.putObject(
            {
              Bucket: Config.obsBucket, // 桶名
              Key: res, // 路径 + 文件名
              SourceFile: file.file
            },
            function(err, result) {
              loading.close()
              if (err) {
                thit.$message({ message: '上传失败', type: 'error' })
              } else {
                thit.$message({ message: '上传成功', type: 'success' })
                thit.editForm.name = file.file.name
                thit.editForm.fileUrl = Config.obsBaseUrl + res
                thit.$forceUpdate()
              }
            }
          )
        })
        .catch((err) => {
          Promise.reject(err)
        })
    },
    //关闭弹窗回调
    dialogCancel() {
      this.$refs['editForm'].resetFields()
      this.dialogVisible = false
      this.editForm = {}
      this.$refs.selectTree.clearHandle()
    },
    //表单提交
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          if (this.editForm.parentId == null) {
            this.editForm.parentId = 0
          }
          this.$post(this.$url.政务文件新增, this.editForm)
            .then((res) => {
              this.$message.success('成功')
              this.dialogCancel()
              this.getTreeList()
            })
            .catch((e) => {})
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.title_header {
  text-align: left;
  padding: 10px 20px 10px 20px;
  background-color: #ffffff;
  margin-bottom: 3px;
}
.container {
  width: 100%;
  height: auto;
  overflow: hidden;
  display: flex;
  margin-top: 5px;
  .left {
    width: 25%;
    height: 800px;
    background: #ffffff;
    overflow-y: auto;
    padding-bottom: 20px;
    .treeHeader {
      width: 100%;
      text-align: center;
      padding: 10px 0;
      border-bottom: 1px solid #ccc;
      .el-button--small {
        width: 80%;
      }
    }
  }
  .right {
    flex: 1;
    padding: 20px;
    background: #ffffff;
    margin-left: 8px;
    .header {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 10px;
    }
    h3 {
      width: 100%;
      text-align: center;
    }
    .empty {
      width: 100%;
      height: 600px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      p {
        margin-top: 10px;
      }
    }
  }
  /deep/ .el-tree-node__content {
    height: 35px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    span {
      display: flex;
      align-items: center;
      &:first-child {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block;
      }
    }
    .icon-folder {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url('~@/assets/images/icon-folder.png') no-repeat;
      margin-right: 5px;
    }
    .icon-doc,
    .icon-docx {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url('~@/assets/images/icon-word.png') no-repeat;
      margin-right: 5px;
    }
    .icon-xls,
    .icon-xlsx {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url('~@/assets/images/icon-excel.png') no-repeat;
      margin-right: 5px;
    }
    .icon-ppt,
    .icon-pptx {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url('~@/assets/images/icon-ppt.png') no-repeat;
      margin-right: 5px;
    }
    .icon-pdf {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url('~@/assets/images/icon-pdf.png') no-repeat;
      margin-right: 5px;
    }
    .icon-jpg {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url('~@/assets/images/icon-jpg.png') no-repeat;
      margin-right: 5px;
    }
    .icon-png {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url('~@/assets/images/icon-png.png') no-repeat;
      margin-right: 5px;
    }
    .icon-zip {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url('~@/assets/images/icon-zip.png') no-repeat;
      margin-right: 5px;
    }
    .icon-rar {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url('~@/assets/images/icon-rar.png') no-repeat;
      margin-right: 5px;
    }
  }
}
</style>
